import { Component } from '@angular/core';
import { Field } from 'ng-formly';

@Component({
  selector: 'formly-timepicker',
  template: `
    <ngb-timepicker [formControl]="formControl"></ngb-timepicker>
  `,
})
export class TimePicker extends Field {
}


// WEBPACK FOOTER //
// ./src/app/shared/components/fields/timepicker.ts